module.exports = __webpack_public_path__ + "img/stock6.76a072d4.png";